import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWeight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWeight"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M9.25 11.25L6.5 8.04724C8.00686 6.92262 9.91912 6.25 12 6.25C14.0809 6.25 15.9931 6.92262 17.5 8.04724L14.75 11.25C13.9966 10.6877 13.0404 10.3514 12 10.3514C10.9596 10.3514 10.0034 10.6877 9.25 11.25Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconWeight;
